import { type CompanyPaymentType, PaymentMethod } from "@/graphql/codegen/graphql"

/**
 * Calculates the index of a payment type among payment types of the same category.
 *
 * For banking payment types (with bankId): counts by account type only
 * For non-banking payment types: counts by account type AND payment method type
 *
 * @param paymentTypes - All payment types in the list
 * @param currentIndex - Index of the current payment type
 * @returns 1-based index among similar payment types
 */
export const calculateSameTypeIndex = (paymentTypes: CompanyPaymentType[], currentIndex: number): number => {
  const currentPaymentType = paymentTypes[currentIndex]

  if (!currentPaymentType) {
    return 1
  }

  const isBankingPaymentType =
    currentPaymentType.paymentMethods?.[0]?.method === PaymentMethod.Wire ||
    currentPaymentType.paymentMethods?.[0]?.method === PaymentMethod.Ach

  if (isBankingPaymentType) {
    // For banking payment types: count by account type only
    return paymentTypes
      .slice(0, currentIndex + 1)
      .filter((type) => type.accountType === currentPaymentType.accountType && Boolean(type.bankId)).length
  } else {
    // For non-banking payment types: count by account type AND payment method type
    const currentPaymentMethod = currentPaymentType.paymentMethods?.[0]?.method

    return paymentTypes
      .slice(0, currentIndex + 1)
      .filter(
        (type) =>
          type.accountType === currentPaymentType.accountType &&
          !type.bankId &&
          type.paymentMethods?.[0]?.method === currentPaymentMethod
      ).length
  }
}
